import axios from "axios";
import { setRemoveAddressData } from "../Redux/features/AddressSlice";
import { setLogOut } from "../Redux/features/AuthSlice";
import { setRemoveCartAndWishListData } from "../Redux/features/ParsistAPIsData";
import { setTempLogOut } from "../Redux/features/TempAuthSlice";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

let store;

export const injectStore = (_store) => {
  store = _store;
};

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] =
      (store.getState()?.login?.token &&
        `Bearer ${store.getState()?.login?.token}`) ||
      (store.getState()?.tempAuth?.token &&
        `Bearer ${store.getState()?.tempAuth?.token}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(setLogOut());
      store.dispatch(setTempLogOut());
      store.dispatch(setRemoveAddressData());
      store.dispatch(setRemoveCartAndWishListData());
    } else {
      return Promise.reject(error.response);
    }
  },
);

export default axiosInstance;
